import { useQuery } from 'react-query';

import { WorkflowService } from '@/api';

export const GetTechnicalInterventionQuery = 'GetTechnicalInterventionQuery';

export const useGetTechnicalInterventionQuery = ({
  fileId,
}: {
  fileId?: string;
}) => {
  const { data: technicalIntervention } = useQuery(
    [GetTechnicalInterventionQuery, { fileId }],
    async () => {
      if (!fileId) {
        return undefined;
      }

      const response = await WorkflowService.getTechnicalInterventionQuery({
        fileId,
      });

      if (response.failure) {
        return undefined;
      }

      return response.value;
    },
  );

  return {
    technicalIntervention,
  };
};
